import { useStaticQuery, graphql } from 'gatsby'

export function useDataFooterByEn() {
    const data = useStaticQuery(graphql`
        {
            menu: allDatoCmsRenshinMenuFooter(sort: { fields: [sorting], order: ASC }, filter: { locale: { eq: "en" } }) {
                nodes {
                    id
                    title
                    url
                    parentSection {
                        id
                        title
                    }
                }
            }

            projects: allDatoCmsRenshinProject(sort: { fields: [sorting], order: ASC }, filter: { locale: { eq: "en" } }) {
                nodes {
                    title
                    urlCode
                    originalId
                }
            }

            copy: datoCmsRenshinPageOther(title: { eq: "License" }, locale: { eq: "en" }) {
                value
            }

            policy: datoCmsRenshinPageOther(title: { eq: "Privacy Policy" }, locale: { eq: "en" }) {
                value
            }

            developer: datoCmsRenshinPageOther(title: { eq: "Developer" }, locale: { eq: "en" }) {
                value
            }

            language: datoCmsRenshinPageOther(title: { eq: "Language" }, locale: { eq: "hy" }) {
                value
            }

            fb: datoCmsRenshinSocial(title: { eq: "Facebook" }, locale: { eq: "en" }) {
                title
                url
            }

            linkedin: datoCmsRenshinSocial(title: { eq: "Linkedin" }, locale: { eq: "en" }) {
                title
                url
            }

            inst: datoCmsRenshinSocial(title: { eq: "Instagram" }, locale: { eq: "en" }) {
                title
                url
            }

            YouTube: datoCmsRenshinSocial(title: { eq: "Youtube" }, locale: { eq: "en" }) {
                title
                url
            }
        }
    `)

    return data
}
